exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CreateNewProtocolPage_page_container{display:flex;flex-direction:column}.CreateNewProtocolPage_freq_cards_container{display:flex;justify-content:space-between}@media only screen and (max-width: 991px){.CreateNewProtocolPage_freq_cards_container{flex-direction:column}}.CreateNewProtocolPage_freq_card{width:48.6%}@media only screen and (max-width: 991px){.CreateNewProtocolPage_freq_card{width:100%}}\n", ""]);

// Exports
exports.locals = {
	"page_container": "CreateNewProtocolPage_page_container",
	"freq_cards_container": "CreateNewProtocolPage_freq_cards_container",
	"freq_card": "CreateNewProtocolPage_freq_card"
};